import { Fragment } from "react"
import CustomSnackbarItem from "./CustomSnackbarItem"
import { useAppSelector } from "app/hooks"
import { useShowCustomSnackbar } from "features/notification/useShowCustomSnackbar"

const CustomSnackbar = () => {
  const customSnackbarInfo = useAppSelector(
    (state) => state.notification.customSnackbarInfo,
  )

  const { handleHideCustomSnackbar } = useShowCustomSnackbar()

  return (
    <Fragment>
      {customSnackbarInfo && (
        <CustomSnackbarItem
          onClose={handleHideCustomSnackbar}
          customSnackbarInfo={customSnackbarInfo}
        />
      )}
    </Fragment>
  )
}

export default CustomSnackbar
